<script lang="ts" setup>
import type { IJob } from '@/types/LP/job'

const { $api } = useNuxtApp()
const { locale } = useI18n()



const sectionData = {
    "section_title": {
        "en": "Featured Jobs",
        "id": "Lowongan Unggulan"
    },
    "section_action":{
        "text_link":{
            "en":"Explore More Jobs",
            "id":"Jelajahi Lowongan"
        }
    }
}

const isLoading = ref(false)
const jobs = ref<IJob[]>([])

onMounted(() => {
    nextTick(async () => {
        isLoading.value = true
        const { data: featuredJobs } = await $api.landingPage.getFeaturedJobs()
        jobs.value = featuredJobs.value.data
        isLoading.value = false
    })
})
</script>

<template>
    <section v-if="isLoading || jobs.length > 0" class="featured-jobs">
        <VContainer>
            <div class="featured-jobs__inner">
                <div class="featured-jobs__header">
                    <SectionTitle 
                        align="left"
                        size="md"
                        :title="sectionData.section_title[locale as 'en' | 'id']"
                    />
                </div>
                <div class="featured-jobs__content">
                    <div v-if="isLoading" class="featured-jobs__listing">
                        <CardJobSkeleton v-for="n in 9" :key="n"/>
                    </div>
                    <div v-else class="featured-jobs__listing">
                        <NuxtLink :to="`job/${job.slug}`"  class="featured-jobs__item" v-for="job in jobs" :key="job.id">
                            <CardJob :job="job"  />
                        </NuxtLink>
                    </div>
                </div>
                <div class="featured-jobs__action">
                     <VBtn class="px-10" :to="{ name: 'job' }">
                        {{ sectionData.section_action.text_link[locale as 'en' | 'id'] }}
                    </VBtn>
                </div>
            </div>
        </VContainer>
    </section>
</template>

<style lang="scss">
.featured-jobs{
    position: relative;
    @include vwUnit('padding', 0 0 100, 0 0 42);
    background-color: #fff;

    &__header{
        @include vwUnit('margin-bottom', 30,24);
    }

    &__listing{
        display: grid;
        grid-template-columns:repeat(3,1fr);
        @include vwUnit('gap', 30,24);

        @media only screen and (max-width: 1199.98px) {
             grid-template-columns:repeat(2,1fr);
        }

        @media only screen and (max-width: 767.98px) {
             grid-template-columns:1fr;
        }
    }



    &__action{
         @include vwUnit('margin-top', 82,42);
        text-align: center;
        @media only screen and (max-width: 767.98px) {
            display: grid;
        }
    }
}
</style>
